import { getCareSourceAttribution } from './careSourceAttribution';
export const buildCareKnowledgePromotionCandidate = ({
  draft = {},
  draftIndex = 0,
  knowledgeType = 'other',
  source = {},
  sourceCollection = 'careSources',
  sourceContext = '',
  sourceTitle = '',
  sourceType = '',
  timelineEntryIds = [],
  timelineDateKeys = [],
  timelineDateSummary = '',
} = {}) => {
  const timelineEntryIndex = Number.isInteger(draft.timelineEntryIndex)
    ? draft.timelineEntryIndex
    : 0;

  return ({
  childId: source.childId || '',
  captureId: source.captureId || source.id || '',
  knowledgeType,
  profileField: draft.profileField || '',
  profileChapterId: draft.profileChapterId || '',
  customFactType: draft.customFactType || '',
  bucket: knowledgeType,
  title: draft.title,
  summary: draft.content,
  sourceText: draft.sourceText,
  sourceRefs: [{
    ...getCareSourceAttribution(source),
    sourceId: source.id || '',
    sourceVersion: source.staffOriginalVersion ? (source.sourceLifecycle?.version || 'initial') : 'initial',
    sourceTitle,
    sourceType,
    sourceContext,
    sourceCollection,
    timelineEntryId: timelineEntryIds[timelineEntryIndex] || timelineEntryIds[0] || '',
    timelineDate: timelineDateKeys[timelineEntryIndex] || timelineDateKeys[0] || '',
    timelineDateLabel: timelineDateKeys[timelineEntryIndex]
      ? ''
      : timelineDateSummary,
    sourceText: draft.sourceText || '',
    confidence: draft.confidence || '',
  }],
  extractionVersion: 'care_source_review_v1',
  editedByUser: true,
  capturedBy: {
    sourceDocumentId: source.id || '',
    sourceContext: source.sourceContext || '',
    confidence: draft.confidence || '',
  },
  evidenceIdentity: {
    sourceCollection,
    sourceId: source.id || '',
    sourceVersion: source.staffOriginalVersion ? (source.sourceLifecycle?.version || 'initial') : 'initial',
    sourceItemId: draft.clientId || (
      !draft.sourceBlockId && draft.sourceSentenceIndex == null
        ? `suggestion:${draftIndex}`
        : ''
    ),
    sourceBlockId: draft.sourceBlockId || '',
    sourceSentenceIndex: draft.sourceSentenceIndex,
  },
  });
};
